export default __webpack_public_path__ + "static/media/anurag.46f53515.jpg";